import axios from "axios";
import { clearLogoutData } from "../logout/action";
import { Partner_Service_URL } from "../Url";

export const saveFirmDetailsActions = {
  SAVE_FIRM_DETAILS_SUCCESS: "SAVE_FIRM_DETAILS_SUCCESS",
  SAVE_FIRM_DETAILS_ERROR: "SAVE_FIRM_DETAILS_ERROR",
};

export function saveFirmDetails(props) {
  const { access_token, values, partnerFirmId } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Partner_Service_URL}/savePartnerFirmDetails?partnerFirmId=${partnerFirmId}`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(saveAccountFirmSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(saveAccountFirmError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(saveAccountFirmError(err));
          return err.response;
        }
      });
}

export function saveAccountFirmError(error) {
  return {
    type: saveFirmDetailsActions.SAVE_FIRM_DETAILS_ERROR,
    payload: error,
  };
}

export function saveAccountFirmSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: saveFirmDetailsActions.SAVE_FIRM_DETAILS_SUCCESS,
      payload: props,
    });
  };
}
